import { InsurancesStatusEnum } from "@frontend/lib/graphql/generated-gql";
import type { InsuranceStatus } from "@frontend/lib/schemas/clientSchema";

/**
 * Checks if the user is in pending prices mode based on insurance statuses.
 * Pending prices mode is active when any insurance has status Unverified, Manuallyverified,
 * or ActiveBenefitsNotReturned (plan is active but benefits are intentionally omitted).
 *
 * @param insuranceStatuses - Array of insurance status results from the insurance check
 * @returns true if any insurance is Unverified or Manuallyverified, false otherwise
 */
export function ShouldChangeToPendingPricesMode(
  insuranceStatuses: InsuranceStatus[] | null,
): boolean {
  if (!insuranceStatuses || insuranceStatuses.length === 0) {
    return false;
  }

  return insuranceStatuses.some(
    (insurance) =>
      insurance.status === InsurancesStatusEnum.Unverified ||
      insurance.status === InsurancesStatusEnum.Manuallyverified ||
      insurance.status === InsurancesStatusEnum.ActiveBenefitsNotReturned ||
      (insurance.status === InsurancesStatusEnum.Active &&
        !insurance.hasBenefits),
  );
}
